import { Link } from 'react-router-dom';

export const PillarCard = ({ icon, title, description, delay }) => (
  <div
    className="group p-8 bg-[#0A0A0A]/80 backdrop-blur-sm border border-zinc-800 hover:border-[#B5FF00]/50 transition-all duration-300 hover:scale-[1.02] opacity-0 animate-fade-in-up cursor-none"
    style={{ animationDelay: `${delay}ms`, animationFillMode: 'forwards' }}
  >
    <div className="text-[#B5FF00] mb-6 group-hover:rotate-12 transition-transform duration-300">
      {icon}
    </div>
    <h3 className="font-['Josefin_Sans'] text-2xl text-white mb-3">{title}</h3>
    <p className="text-zinc-400 leading-relaxed">{description}</p>
  </div>
);

export const StepCard = ({ number, icon, title, description, delay }) => (
  <div
    className="text-center group opacity-0 animate-fade-in-up cursor-none"
    style={{ animationDelay: `${delay}ms`, animationFillMode: 'forwards' }}
  >
    <div className="relative inline-block mb-6">
      <span className="font-['Josefin_Sans'] text-7xl md:text-8xl font-bold text-zinc-900 group-hover:text-zinc-800 group-hover:scale-110 transition-all duration-300">
        {number}
      </span>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[#B5FF00]">
        {icon}
      </div>
    </div>
    <h3 className="font-['Josefin_Sans'] text-xl text-white mb-2">{title}</h3>
    <p className="text-zinc-500 text-sm">{description}</p>
  </div>
);

export const StatBlock = ({ value, label }) => (
  <div className="text-center">
    <div className="font-['Josefin_Sans'] text-5xl md:text-6xl font-bold text-[#B5FF00] mb-2 neon-text-glow">
      {value}
    </div>
    <div className="font-mono text-sm text-zinc-500 tracking-widest uppercase">
      {label}
    </div>
  </div>
);

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return {
    day: date.getDate(),
    month: date.toLocaleDateString('en-GB', { month: 'short' }).toUpperCase(),
  };
};

export const FeaturedEventCard = ({ event, index }) => {
  const { day, month } = formatDate(event.date);

  return (
    <Link
      to={`/events/${event.id}`}
      className="group relative h-[350px] overflow-hidden border border-zinc-800 hover:border-[#B5FF00]/40 transition-all duration-300 opacity-0 animate-fade-in-up cursor-none text-left w-full block"
      style={{ animationDelay: `${index * 100}ms`, animationFillMode: 'forwards' }}
      data-testid={`featured-event-${event.id}`}
    >
      <div className="absolute inset-0">
        <img
          src={event.image_url}
          alt={event.title}
          className="w-full h-full object-cover img-grayscale group-hover:scale-105 group-hover:grayscale-0 transition-all duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/60 to-transparent" />
      </div>

      <div className="absolute top-4 right-4 bg-[#050505]/80 backdrop-blur-sm border border-zinc-800 p-3 text-center">
        <div className="font-['Josefin_Sans'] text-xl font-bold text-white leading-none">{day}</div>
        <div className="font-mono text-xs text-[#B5FF00]">{month}</div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 p-6">
        <span className="font-mono text-xs text-[#B5FF00] tracking-widest mb-2 block">
          {event.genre.toUpperCase()}
        </span>
        <h3 className="font-['Josefin_Sans'] text-2xl text-white mb-2 group-hover:text-[#B5FF00] transition-colors">
          {event.title}
        </h3>
        <p className="text-zinc-500 text-sm">{event.venue}</p>
      </div>
    </Link>
  );
};
